<template>
	<div
		style="display: flex"
		class="pl-12 pt-12 pr-8 flex-col gap-4"
	>
		<div
			style="display: flex"
			class="justify-center"
		>
			<Breadcrumb
				v-model="step"
				:crumbs="[
					{ name: 'Cadastro', step: 1 },
					{ name: 'Planejamento', step: 2 },
				]"
			/>
		</div>
		<div>
			<h1 class="text-H5">Cadastrar Ordem de Serviço</h1>
			<p class="text-default">Defina os parâmetros da Ordem de Serviço</p>
		</div>
		<div
			style="display: flex"
			class="gap-2 flex-col"
		>
			<Input
				v-model="ordemServico.orsv_ds_descricao"
				label="Descrição"
				placeholder="Digite aqui"
			/>
			<Dropdown
				v-model="ordemServico.fk_esfl_estrato_florestal"
				label="Estrato florestal"
				:options="estratosDropdown"
			/>
			<Dropdown
				v-model="ordemServico.fk_tpsv_tipo_servico"
				label="tipo de serviço"
				:options="tiposDeServicosDropdown"
			/>
			<DataPicker
				v-model="dataInicio"
				label="data inicial*"
				placeholder="Selecione a data"
				:min-date="new Date().toDateString()"
			/>

			<DataPicker
				v-model="dataFinal"
				label="data final*"
				placeholder="Selecione a data"
				:min-date="ordemServico.orsv_dt_data_inicial"
			/>
			<Dropdown
				v-model="ordemServico.executoresIds"
				label="coletores"
				:options="executoresDropdown"
			/>
			<Dropdown
				v-show="showCamposParcela"
				v-model="ordemServico.orsv_tx_forma_parcela"
				label="formato da parcela"
				:options="[
					{ label: 'Circular', value: 'Circular' },
					{ label: 'Quadrada', value: 'Quadrada' },
					{ label: 'Retangular', value: 'Retangular' },
				]"
			/>
			<Input
				v-show="showCamposParcela"
				v-model.number="ordemServico.orsv_md_medida_parcela"
				label="tamanho da parcela (m²)"
				placeholder="Digite aqui"
			/>
			<Input
				v-model.number="ordemServico.orsv_md_geofence"
				label="Geofence"
				placeholder="Digite aqui"
			/>

			<div
				style="display: flex"
				class="gap-4 w-full justify-between mt-8"
			>
				<Button
					text="voltar"
					secondary
					class="w-1/2 justify-center"
					@click="$emit('close')"
				/>
				<Button
					:loading="createStatus === 'pending'"
					text="avançar"
					class="w-1/2 justify-center"
					@click="$emit('advance')"
				/>
			</div>
		</div>
	</div>
</template>

<script setup>
import { computed, onMounted, ref, watch } from 'vue'
import Breadcrumb from '../../../components/ui/breadcrumb/Breadcrumb.vue'
import Button from '../../../components/ui/button/Button.vue'
import DataPicker from '../../../components/ui/dataPicker/DataPicker.vue'
import Dropdown from '../../../components/ui/dropdown/Dropdown.vue'
import Input from '../../../components/ui/input/Input.vue'
import { useOrdemServico } from '../../../composables/useOrdemServico'
import { getDropdowns } from '../../../services/requests/OrdemDeServicoRequests'
const step = ref(1)
const {
	estratosDropdown,
	executoresDropdown,
	tiposDeServicosDropdown,
	codigoTipoServico,
	dropdowns,
} = useDropdowns()
const { ordemServico, createStatus } = useOrdemServico()

const showCamposParcela = computed(() => {
	return !['005', '007', '018'].includes(codigoTipoServico.value)
})

watch(
	() => ordemServico.value.fk_tpsv_tipo_servico,
	(newValue) => {
		const tipo = dropdowns.value.tiposDeServicos.find((tipo) => {
			return tipo.id === newValue
		})
		ordemServico.value.tpsv_cd_codigo = tipo.codigo
		ordemServico.value.orsv_cd_tipo_servico = tipo.codigo
		ordemServico.value.tpsv_ds_descricao = tipo.descricao
	},
)

const dataInicio = computed({
	get() {
		const reversedDate = ordemServico.value.orsv_dt_data_inicial.split('/').reverse().join('-')
		return new Date(reversedDate).toISOString()
	},
	set(v) {
		ordemServico.value.orsv_dt_data_inicial = new Date(v).toLocaleDateString()
	},
})

const dataFinal = computed({
	get() {
		const reversedDate = ordemServico.value.orsv_dt_prazo_final.split('/').reverse().join('-')
		return new Date(reversedDate).toISOString()
	},
	set(v) {
		ordemServico.value.orsv_dt_prazo_final = new Date(v).toLocaleDateString()
	},
})

function useDropdowns() {
	const dropdowns = ref({
		estratosFlorestais: [],
		executores: [],
		tiposDeServicos: [],
	})

	const codigoTipoServico = computed(() => {
		return dropdowns.value.tiposDeServicos.find(
			(tipo) => tipo.id === ordemServico.value.fk_tpsv_tipo_servico,
		)?.codigo
	})

	onMounted(() => {
		getDropdowns().then((data) => {
			dropdowns.value = data.data.result
		})
	})

	const estratosDropdown = computed(() => {
		return dropdowns.value.estratosFlorestais.map((estrato) => {
			return {
				label: `${estrato.codigo} - ${estrato.descricao}`,
				value: estrato.id,
			}
		})
	})

	const executoresDropdown = computed(() => {
		return dropdowns.value.executores.map((executor) => {
			return {
				label: `${executor.codigo} - ${executor.nome}`,
				value: executor.id,
			}
		})
	})

	const tiposDeServicosDropdown = computed(() => {
		return dropdowns.value.tiposDeServicos
			.filter((tipo) =>
				['001', '002', '003', '005', '007', '008', '018', '019'].includes(tipo.codigo),
			)
			.map((tipo) => {
				return {
					label: `${tipo.codigo} - ${tipo.descricao}`,
					value: tipo.id,
				}
			})
	})

	return {
		estratosDropdown,
		executoresDropdown,
		tiposDeServicosDropdown,
		codigoTipoServico,
		dropdowns,
	}
}
</script>

<style scoped></style>
